// this file is generated by update_shopify_store_data.py at 2025-12-03 20:29:06.562368
var courses = [
    {
        "course_id": "F208EBA0-8014-F011-9997-005056A726F7",
        "course_version": 1,
        "name": "Pain Assessment for Hospitalized Individuals with Intellectual and Developmental Disabilities (IDD)",
        "course_type": 1,
        "author_information": "Dr. Amy Jerum, DNP, RN, CPNP-PC, PMHS-BC, PMHNP; and \r\nDr. Jane Tobias, DNP, CRNP, CPNP-BC",
        "description": "Management of pain is critical to improving outcomes for hospitalized patients. The recognition of pain for hospitalized patients with intellectual and developmental disabilities has historically been challenging for providers. In this module, you will explore strategies for the identification and assessment of pain presenting in hospitalized patients with intellectual and developmental disabilities. You will learn how to transform assessment data into strategies for effective pain management for your patient.",
        "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Describe the challenges of pain assessment in a patient with an intellectual and developmental disability (IDD)</li>\r\n    <li>Recognize symptoms of pain in a patient with an IDD</li>\r\n    <li>Describe pain assessment tools utilized in assessing pain in a&nbsp;patient with an IDD</li>\r\n    <li>Implement effective pain assessment strategies for the hospitalized patient with IDD</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                "course_category_name": "Golisano-CEUnlimited",
                "is_system_course_category": null
            },
            {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Advance Practice Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5AE0CD99-4B63-4719-B571-1B7E15ADCBA7",
                "course_category_name": "RN-BC: Pain Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
            "credit_display_name": "ANCC",
            "credit_units": 0.75,
            "credit_unit_display_name": "Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];